<template>
  <label class="flex items-center xs:max-w-fit cursor-pointer text-label">
    <div :class="{ 'border-2 border-solid rounded border-linear-strong p-0.5': guest }">
      <input
        class="flex items-center appearance-none w-4 h-4 border border-solid border-linear-strong rounded"
        :class="
          guest
            ? 'checked:bg-fg-g-primary bg-body-primary'
            : 'checked:bg-button-primary bg-surface-base'
        "
        type="checkbox"
        @change="onChange"
        :checked="modelValue"
      />
    </div>
    <div class="ml-1 font-label text-fg-secondary guest-ui:text-fg-disclaimer uppercase text-xs">
      {{ label }}
    </div>
  </label>
</template>
<script lang="ts">
import { defineComponent } from 'vue'

export default defineComponent({
  name: 'CheckboxInput',
  model: {
    prop: 'modelValue',
    event: 'update:modelValue',
  },
  props: {
    modelValue: {
      type: Boolean,
      required: true,
    },
    label: {
      type: String,
      required: false,
    },
    guest: {
      type: Boolean,
      required: false,
    },
  },
  emits: {
    // eslint-disable-next-line no-unused-vars
    'update:modelValue': (_value: boolean) => true,
  },
  methods: {
    onChange(e) {
      this.$emit('update:modelValue', e.target.checked)
    },
  },
})
</script>
